export const WS_URL = 'https://chat-application-9354.onrender.com';
